import styles from './other.module.scss'
import Loading from '@/components/Loading/Loading'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import CachedIcon from '@mui/icons-material/Cached'
import { removeServiceWorker } from '@/modules/utils/serviceWorker'
import { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'

interface MainLoadingProps {
    isParent?: boolean
}

const MainLoading: FunctionComponent<MainLoadingProps> = ({ isParent = false }: MainLoadingProps) => {
    const { t } = useTranslation()

    return (
        <main>
            <div className={styles.Main}>
                <Loading overall={false} />
                <ButtonTextIcon
                    type={'custom'}
                    customText={t('refresh')}
                    customIcon={<CachedIcon />}
                    onClick={removeServiceWorker}
                    className={styles.Button}
                    parent={isParent}
                />
            </div>
        </main>
    )
}

export default MainLoading
